<template>
  <td class="text-center state-disabled" width="5%">
    <b>
      <slot name="after"></slot>
      {{index + 1}}.
      <slot name="before"></slot>
    </b>
  </td>
</template>

<script>
export default {
  name: 'w-lp-cell',
  props: {
    index: {
      type: Number,
      required: true
    }
  }
};
</script>